import React, { useEffect, useState } from "react";
import { BoardView } from "../board/BoardRenderer";
import { DEMO_AGENCY } from "../board/demo/demoAgency";
import { withDemoContent } from "../board/demo/demoContent";
import { setPreviewStill } from "../board/boardData";
import { PREVIEW_SOURCE, readRenderMessage, sanitizeConfig } from "./previewProtocol";

// Live preview for the admin dashboard's Station Board Studio: the real board
// renderer and widgets, fed by the fictional demo agency (see index.js, which
// switches the data layer to demo mode before this mounts). Never signs in and
// never reads a real agency.
const PreviewApp = () => {
  const [config, setConfig] = useState(null);
  const [screenId, setScreenId] = useState(null);

  useEffect(() => {
    const onMessage = (event) => {
      const msg = readRenderMessage(event);
      if (!msg) return;
      setPreviewStill(msg.still);
      setConfig(withDemoContent(sanitizeConfig(msg.config)));
      setScreenId(msg.screenId);
    };
    window.addEventListener("message", onMessage);
    // Tell the Studio we're listening. Carries no data, so any target is fine.
    if (window.parent && window.parent !== window) {
      window.parent.postMessage({ source: PREVIEW_SOURCE, type: "ready" }, "*");
    }
    return () => window.removeEventListener("message", onMessage);
  }, []);

  if (!config) {
    return (
      <div className="sb-stage-bg" style={{ background: "#0b0b0d" }}>
        <div className="sb-board-waiting">
          {window.parent !== window ? "Loading preview…" : "Open this preview from Station Board Studio."}
        </div>
      </div>
    );
  }
  return <BoardView boardConfig={config} agency={DEMO_AGENCY} forceScreenId={screenId} />;
};

export default PreviewApp;
